var map = {
	"./app-icon.svg": 1721,
	"./caret-right-icon.svg": 1722,
	"./chrome-icon.webp": 1723,
	"./edge-icon.webp": 1724,
	"./firefox-icon.webp": 1725,
	"./opera-icon.webp": 1726,
	"./safari-icon.webp": 1727,
	"./unknown-icon.webp": 1728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1720;